import ApiBase from '../ApiBase';

class Absence extends ApiBase {
  /**
   * @method get
   * @param {number} page
   * @param {string|null} userId
   * @return {*}
   */
  fetch = (page, userId = null) => {
    return this.get('absences', {
      page,
      user_id: userId,
    });
  };

  /**
   * @method create
   * @param {object} data
   * @return {Promise<*>}
   */
  create = (data) => {
    return this.post('absences', data, 'create', 201, {
        headers: {
            "Content-Type": undefined
        }
    });
  };

  /**
   * @method remove
   * @param {string} id
   * @return {Promise<*>}
   */
  remove = (id) => {
    return this.delete(`absences/${id}`, 'delete');
  };
}

export default new Absence();

